export const htmlSerializerBreak = <T>(text: T): T | string => {
  if (typeof text !== 'string') return text;
  return text.replaceAll('\n', '</br>');
};
